import { Markup } from 'interweave';
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {  getTermsData } from '../../Redux/ActionCreater';


function TermsCondition() {
    const [terms,setTerms]=useState();
    const [loading,setLoading]=useState(true);
    const dispatch = useDispatch();
  const state = useSelector(
    (state) => (
       state.dataReducer
    ),
    shallowEqual
  );
    useEffect(() => {
        fetchData()
      }, [])
    
     
      const fetchData = async () => {
      
        let header={
          headers:{
          "X-Auth-Token":"12345"
        }};
        dispatch(getTermsData(header));
        
      };

      useEffect(() => {
        setTerms(state.termsData);
        setLoading(state.isLoading)
        }, [state])
  return (
    <>
    
    <>
    <Helmet>
          <title>{`CNC Machine :: ${terms?.page_title}`}</title>
          <meta name="description" content={terms?.meta_description} />
          <meta name="keywords" content={terms?.meta_keywords} />
          <meta name="title" content={terms?.meta_title} />
          <meta property="og:title" content={`CNC Machine :: ${terms?.page_title}`}/>

        </Helmet>
    
    <section className="aboutcontainer">
    {loading===true?<div className="loader-container">
        <div className="spinner"></div>
      </div>:
  <div className="container">
    <div className="row">
      <div className="col-12">
        <h2>Terms and <span>Conditions</span></h2>
      <Markup content={terms?.page_content} />
        
      </div>
    </div>
  </div>}
</section>
    </>

    </>
  )
}

export default TermsCondition